





























































































import { DateRange } from '@/models';
import { isMaxLengthRuleBroken, dateRangeMixin } from '@/shared';
import { Actions } from '@/store';
import { resetModel } from '@/utils';
import moment from 'moment';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default mixins(dateRangeMixin).extend({
  name: 'AddSeasonModal',
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      form: {
        name: '',
      },
    };
  },
  computed: {
    datesUntilStartDate(): DateRange {
      return this.form.startDate
        ? { to: this.form.startDate }
        : { from: null, to: null } as unknown as DateRange;
    },
  },
  methods: {
    areErrorMessagesDisplayed(field: string): boolean {
      return isMaxLengthRuleBroken(this, field);
    },
    resetForm() {
      this.form = resetModel(this.form);
      this.dateRange = null as unknown as DateRange;
    },
    async addSeason() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.seasons.addSeason,
          {
            name: this.form.name,
            start: moment(this.form.startDate).startOf('day'),
            end: moment(this.form.endDate).endOf('day'),
          },
        );
        this.$bvModal.hide('add-season-modal');
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
});
